(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-swiper-quantity"] && !Shopify.designMode) return;
  try {
    

  // ── External Swiper initialiser ────────────────────────────────────────────
  // Runs at DOMContentLoaded — before Alpine's init() — so Swiper is always
  // created by this function. Slide changes are communicated to Alpine via a
  // custom event on the section root, which Alpine listens for in init().
  const initQtyPdpSwiper = (root) => {
    if (typeof window.Swiper === 'undefined') return

    // Media swipers (left column on slide 0 and review slide)
    root.querySelectorAll('.pdp-swiper__media-swiper').forEach((mediaEl) => {
      if (mediaEl.swiper) return
      new window.Swiper(mediaEl, {
        nested: true,
        slidesPerView: 1,
        speed: 650,
        breakpoints: { 990: { allowTouchMove: false, simulateTouch: false } },
      })
    })

    // Root Swiper — controls all step slides
    const rootEl = root.querySelector('.pdp-swiper__root')
    if (!rootEl || rootEl.swiper) return
    new window.Swiper(rootEl, {
      slidesPerView: 1,
      speed: 700,
      allowTouchMove: false,
      simulateTouch: false,
      // autoHeight lets the wrapper grow with each slide's content on mobile,
      // where the section itself is height:auto. On desktop (>=750px) the
      // section is pinned to a computed viewport height with an internally
      // scrolling aside — autoHeight there sets an inline height on
      // .swiper-wrapper that fights that fixed-height layout, so it's
      // switched off at the same breakpoint the CSS uses.
      autoHeight: true,
      breakpoints: {
        750: { autoHeight: false },
      },
      on: {
        slideChange(sw) {
          root.dispatchEvent(
            new CustomEvent('pdp-swiper-qty:slide-change', {
              bubbles: false,
              detail: { activeIndex: sw.activeIndex },
            })
          )
        },
      },
    })

    // Mark the section ready once the root Swiper exists. Until this point
    // .swiper-wrapper has no transform, so the review step's position:fixed
    // ADD TO CART row escapes the .swiper overflow clip and flashes in the
    // viewport corner on load. CSS keeps that row (and any non-first slide's
    // fixed CTA) hidden while .is-swiper-ready is absent.
    root.classList.add('is-swiper-ready')
  }

  const _runQtyPdpSwiperInit = () => {
    document.querySelectorAll('.pdp-swiper-qty').forEach(initQtyPdpSwiper)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _runQtyPdpSwiperInit)
  } else {
    _runQtyPdpSwiperInit()
  }

  // Fallback: swiper-bundle.min.js is defer-loaded in theme.liquid and may not
  // be available yet at DOMContentLoaded when this section's compiled JS runs first.
  // window.load fires after all deferred scripts have executed, ensuring Swiper
  // is defined. initQtyPdpSwiper guards against double-init via rootEl.swiper check.
  window.addEventListener('load', _runQtyPdpSwiperInit, { once: true })

  // ── Discount / product-type rule parsers ───────────────────────────────────

  const parseDiscountByProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const idx = segment.lastIndexOf('/')
        if (idx === -1) return null
        const productType = segment.slice(0, idx).trim()
        const percent = segment.slice(idx + 1).trim()
        if (!productType || !percent) return null
        return { productType, percent: Number(percent) }
      })
      .filter(Boolean)
  }

  const parseQtyAddonProductTypeRules = (raw) => {
    if (!raw || typeof raw !== 'string') return []
    return raw
      .replace(/\r\n/g, '\n')
      .split(/[,\n]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((segment) => {
        const parts = segment.split('|').map((p) => p.trim())
        const match = parts[0]
        const productType = parts[1] || ''
        const collectionFilter = parts[2] || null
        if (!match || !productType) return null
        return { match, productType, collectionFilter }
      })
      .filter(Boolean)
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('pdpSwiperQuantityState', () => ({

      // ── Variant data ────────────────────────────────────────────────
      productHandle: '',
      variantsById: {},
      addonVariantsById: {},
      defaultByOption1: {},
      addonProductTypeMap: '',
      discountByProductTypeMap: '',
      reviewImageMappings: [],
      productFeaturedImage: '',
      bundleVariantId: '',
      bundleVariant: null,
      bundleSlotsByType: {},

      // ── Step 1 quantity state ────────────────────────────────────────
      // { [option1Key]: 0..3 }
      quantityByOption1: {},

      // ── Step 1 slot color state ──────────────────────────────────────
      // { [option1Key]: [variantId, variantId, ...] }  length === qty
      slotColorByOption1: {},

      // ── Swatch data (baked from Liquid) ──────────────────────────────
      // { [option1Key]: [{ variantId, option2, swatchBg }, ...] }
      swatchesByOption1: {},

      // Ordered list of option1 keys (Liquid render order)
      option1Order: [],

      // ── Bundle list (built on NEXT from Step 1) ──────────────────────
      bundles: [],

      // ── Addon type groups (derived from bundles, drives addon slides) ─
      // [{ productType, count, bundles[], label }]
      addonTypeGroups: [],

      // ── Scent qty per type: { [productType]: { [addonVariantId]: qty } }
      addonQtyByType: {},

      // ── Swiper tracking ──────────────────────────────────────────────
      currentSwiperIndex: 0,
      stepTextTemplate: '',
      showReviewStep: true,
      singleSelection: false,

      // ── Shared UI state ─────────────────────────────────────────────
      termsAccepted: false,
      termsAcceptedAt: null,
      termsModalOpen: false,
      addToCartLoading: false,
      popupOpen: false,
      popupVariant: null,
      popupOption1: null,
      popupSectionsCache: {},
      popupSectionsHtml: '',
      addonPopupOpen: false,
      addonPopupVariant: null,
      addonPopupSectionsCache: {},
      addonPopupSectionsHtml: '',
      allScentsModalOpen: false,
      allScentsSearch: '',
      allScentsInspiredByOpen: true,
      allScentsDrawerOpen: false,
      selectedInspiredByFilters: [],
      _allScentsProductType: null,
      _allScentsCollectionFilter: null,
      pdpSwiperRootEl: null,

      // ── Init ────────────────────────────────────────────────────────
      init() {
        this.pdpSwiperRootEl =
          this.$el && this.$el.closest ? this.$el.closest('.pdp-swiper-qty') : null

        const jsonEl = this.$el.querySelector('[data-pdp-variant-state]')
        if (!jsonEl) return

        let state = null
        try {
          state = JSON.parse(jsonEl.textContent || '{}')
        } catch (e) {
          state = null
        }
        if (!state) return

        // Populate variantsById
        ;(state.variants || []).forEach((v) => {
          this.variantsById[String(v.id)] = v
        })

        // Populate addonVariantsById
        this.addonVariantsById = {}
        ;(state.addonVariants || []).forEach((row) => {
          if (row && row.id != null) {
            this.addonVariantsById[String(row.id)] = row
          }
        })

        this.defaultByOption1 = { ...(state.defaults || {}) }
        this.addonProductTypeMap =
          typeof state.addonProductTypeMap === 'string' ? state.addonProductTypeMap : ''
        this.discountByProductTypeMap =
          typeof state.discountByProductTypeMap === 'string'
            ? state.discountByProductTypeMap
            : ''
        this.reviewImageMappings = Array.isArray(state.reviewImageMappings)
          ? state.reviewImageMappings
          : []
        this.productFeaturedImage = state.productFeaturedImage || ''
        this.productHandle = state.productHandle || ''

        this.bundleVariantId = state.bundleVariantId || ''
        this.bundleVariant = this.bundleVariantId
          ? (Object.values(this.variantsById).find((v) => v.option1 === this.bundleVariantId) || null)
          : null

        // Swatch data per option1 group
        this.swatchesByOption1 =
          state.swatchesByOption1 && typeof state.swatchesByOption1 === 'object'
            ? state.swatchesByOption1
            : {}

        // Ordered option1 keys (Liquid render order for bundle building)
        this.option1Order = Array.isArray(state.option1Order) ? state.option1Order : []

        // Initialize quantityByOption1: all option1 groups start at 0
        const qtyInit = {}
        Object.keys(this.defaultByOption1).forEach((key) => {
          qtyInit[key] = 0
        })
        this.quantityByOption1 = qtyInit
        this.slotColorByOption1 = {}

        // Step text template for addon slides ("Step {step_number}: ...")
        this.stepTextTemplate = typeof state.stepTextTemplate === 'string'
          ? state.stepTextTemplate
          : 'Step {step_number}: Choose your scent.'

        this.showReviewStep = state.showReviewStep !== false
        this.singleSelection = state.singleSelection === true
        if (this.singleSelection) this.preselectSingleDiffuser()

        // Listen for slide changes dispatched by the external Swiper init
        const root = this.pdpSwiperRootEl
        if (root) {
          root.addEventListener('pdp-swiper-qty:slide-change', (e) => {
            this.currentSwiperIndex = (e.detail && e.detail.activeIndex != null)
              ? e.detail.activeIndex
              : 0
          })
        }
      },

      // ── Quantity helpers ─────────────────────────────────────────────
      getQty(option1Key) {
        return Number(this.quantityByOption1[option1Key] || 0)
      },

      incrementQty(option1Key) {
        const current = this.getQty(option1Key)
        // Single Selection preselects the first diffuser but allows up to 5 units per selector.
        if (this.singleSelection && current >= 5) return
        const weight = option1Key === '__bundle__' ? 3 : 1
        if (this.totalWeightedUnits() + weight > 5) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current + 1 }
        if (option1Key === '__bundle__') {
          const typeOrder = this.getBundleTypeOrder()
          const newSlots = { ...this.bundleSlotsByType }
          typeOrder.forEach((t) => {
            const existing = [...(newSlots[t.productType] || [])]
            existing.push(t.swatches.length ? t.swatches[0].variantId : null)
            newSlots[t.productType] = existing
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.push(this.firstSwatchVariantIdForOption1(option1Key))
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      decrementQty(option1Key) {
        const current = this.getQty(option1Key)
        if (current <= 0) return
        this.quantityByOption1 = { ...this.quantityByOption1, [option1Key]: current - 1 }
        if (option1Key === '__bundle__') {
          const newSlots = { ...this.bundleSlotsByType }
          Object.keys(newSlots).forEach((pt) => {
            newSlots[pt] = newSlots[pt].slice(0, -1)
          })
          this.bundleSlotsByType = newSlots
        } else {
          const existing = [...(this.slotColorByOption1[option1Key] || [])]
          existing.pop()
          this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: existing }
        }
      },

      // Single Selection: preselect the first available (non-bundle) diffuser
      // on Step 1 so the flow starts with one product chosen. The quantity
      // stepper stays visible (capped at 1). Called on init when enabled.
      preselectSingleDiffuser() {
        if (this.totalUnits() > 0) return
        const bundleO1 = this.bundleVariant ? (this.bundleVariant.option1 || '') : ''
        const firstKey = (this.option1Order || []).find(
          (k) => k && k !== bundleO1 && this.quantityByOption1[k] != null
        )
        if (firstKey) this.incrementQty(firstKey)
      },

      totalUnits() {
        return Object.values(this.quantityByOption1).reduce(
          (sum, q) => sum + (Number(q) || 0),
          0
        )
      },

      totalWeightedUnits() {
        const bundleQty = this.getQty('__bundle__')
        const regularQty = Object.entries(this.quantityByOption1)
          .filter(([key]) => key !== '__bundle__')
          .reduce((sum, [, q]) => sum + (Number(q) || 0), 0)
        return regularQty + bundleQty * 3
      },

      canAdvanceFromStep1() {
        if (this.totalUnits() === 0) return false
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0) {
          const typeOrder = this.getBundleTypeOrder()
          for (let ti = 0; ti < typeOrder.length; ti++) {
            const slots = this.bundleSlotsByType[typeOrder[ti].productType] || []
            for (let i = 0; i < bundleQty; i++) {
              if (!slots[i]) return false
            }
          }
        }
        return true
      },

      // ── Swatch / slot helpers ────────────────────────────────────────
      getSwatchesForOption1(option1Key) {
        const swatches = this.swatchesByOption1[option1Key] || []
        const BLACK = 'Black by Aroma360'
        const blackIdx = swatches.findIndex(sw => sw.option2 === BLACK)
        if (blackIdx > 0) {
          const reordered = [...swatches]
          reordered.unshift(reordered.splice(blackIdx, 1)[0])
          return reordered
        }
        return swatches
      },

      firstSwatchVariantIdForOption1(option1Key) {
        const swatches = this.getSwatchesForOption1(option1Key)
        if (swatches.length) return swatches[0].variantId
        // Fallback to the defaults map if no swatch data (single-option products)
        return this.defaultByOption1[option1Key] || null
      },

      getSlotVariantId(option1Key, slotIndex) {
        const slots = this.slotColorByOption1[option1Key] || []
        return slots[slotIndex] != null ? slots[slotIndex] : null
      },

      // ── Bundle slot helpers ──────────────────────────────────────────
      getBundleTypeOrder() {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const bundleOption1 = this.bundleVariant ? (this.bundleVariant.option1 || '') : ''
        const seen = new Set()
        return this.option1Order
          .filter((o1) => !bundleOption1 || o1 !== bundleOption1)
          .map((o1) => {
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                const rule = rules[i]
                const compositeKey = rule.collectionFilter
                  ? rule.productType + '::' + rule.collectionFilter
                  : rule.productType
                return { option1: o1, productType: compositeKey, swatches: this.swatchesByOption1[o1] || [] }
              }
            }
            return null
          })
          .filter(Boolean)
          .filter((t) => {
            if (seen.has(t.productType)) return false
            seen.add(t.productType)
            return true
          })
      },

      getBundleUnitCount() {
        return this.getQty('__bundle__')
      },

      isBundleSlotSelected(productType, unitIdx, variantId) {
        const slots = this.bundleSlotsByType[productType] || []
        return slots[unitIdx] === variantId
      },

      setBundleSlotColor(productType, unitIdx, variantId) {
        const slots = [...(this.bundleSlotsByType[productType] || [])]
        slots[unitIdx] = variantId
        this.bundleSlotsByType = { ...this.bundleSlotsByType, [productType]: slots }
      },

      getBundleSlotColorName(productType, unitIdx) {
        const slots = this.bundleSlotsByType[productType] || []
        const variantId = slots[unitIdx]
        if (!variantId) return ''
        const v = this.variantsById[String(variantId)]
        return v ? (v.option2 || '') : ''
      },

      setSlotColor(option1Key, slotIndex, variantId) {
        const slots = [...(this.slotColorByOption1[option1Key] || [])]
        slots[slotIndex] = variantId
        this.slotColorByOption1 = { ...this.slotColorByOption1, [option1Key]: slots }
      },

      isSlotSwatchSelected(option1Key, slotIndex, variantId) {
        const current = this.getSlotVariantId(option1Key, slotIndex)
        return Number(current) === Number(variantId)
      },
      getSlotColorName(option1Key, slotIndex) {
        const variantId = this.getSlotVariantId(option1Key, slotIndex)
        const v = variantId ? this.variantsById[String(variantId)] : null
        return v ? (v.option2 || '') : ''
      },

      // ── Build flat bundle list ───────────────────────────────────────
      // Called when user clicks NEXT on Step 1.
      // Produces: [{ bundleId, variantId, option1, option2, productType }, ...]
      buildBundles() {
        const order = this.option1Order.length
          ? this.option1Order
          : Object.keys(this.quantityByOption1)

        const bundles = []
        order.forEach((option1Key) => {
          const qty = this.getQty(option1Key)
          const slots = this.slotColorByOption1[option1Key] || []
          for (let i = 0; i < qty; i++) {
            const variantId =
              slots[i] != null
                ? slots[i]
                : this.firstSwatchVariantIdForOption1(option1Key)
            if (!variantId) continue
            const variant = this.getVariantById(variantId)
            if (!variant) continue
            const bundle = {
              bundleId: `_bundle_qty_${variantId}_s${i}_${Date.now()}_${Math.random()
                .toString(36)
                .slice(2, 7)}`,
              variantId: Number(variantId),
              option1: variant.option1 || option1Key,
              option2: variant.option2 || '',
            }
            bundle.productType = this.expectedAddonProductTypeForBundle(bundle)
            bundles.push(bundle)
          }
        })
        // Bundle card entries — one per type per unit
        const bundleQty = this.getQty('__bundle__')
        if (bundleQty > 0 && this.bundleVariant) {
          const typeOrder = this.getBundleTypeOrder()
          for (let unitIdx = 0; unitIdx < bundleQty; unitIdx++) {
            typeOrder.forEach((t) => {
              const slotVarId = (this.bundleSlotsByType[t.productType] || [])[unitIdx]
                || (t.swatches.length ? t.swatches[0].variantId : null)
              if (!slotVarId) return
              const variant = this.getVariantById(slotVarId)
              if (!variant) return
              const bEntry = {
                bundleId: `_bundle_qty_${slotVarId}_u${unitIdx}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
                variantId: Number(slotVarId),
                option1: variant.option1 || t.option1,
                option2: variant.option2 || '',
                isBundle: true,
                bundleUnitIdx: unitIdx,
              }
              bEntry.productType = this.expectedAddonProductTypeForBundle(bEntry)
              bundles.push(bEntry)
            })
          }
        }

        this.bundles = bundles
        const newGroups = this.buildAddonTypeGroups(bundles)
        this.addonTypeGroups = newGroups

        // Preserve existing scent selections — clip to new limits, drop removed types
        const preserved = {}
        newGroups.forEach((group) => {
          const existing = this.addonQtyByType[group.productType] || {}
          const limit = group.count
          let total = 0
          const clipped = {}
          Object.entries(existing).forEach(([variantId, qty]) => {
            const q = Number(qty) || 0
            if (q <= 0) return
            const take = Math.min(q, limit - total)
            if (take > 0) { clipped[variantId] = take; total += take }
          })
          preserved[group.productType] = clipped
        })
        this.addonQtyByType = preserved

        // After Alpine renders the new x-for slides, update Swiper and advance to slide 1
        this.$nextTick(() => {
          const root = this.pdpSwiperRootEl
          if (!root) return
          const rootEl = root.querySelector('.pdp-swiper__root')
          if (!rootEl || !rootEl.swiper) return
          rootEl.swiper.update()
          rootEl.swiper.slideTo(1, 700)
          if (typeof window !== 'undefined' && window.matchMedia &&
              window.matchMedia('(max-width: 989px)').matches) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        })
      },

      // ── Variant lookup helpers ───────────────────────────────────────
      getVariantById(id) {
        if (!id) return null
        return this.variantsById[String(id)] || null
      },

      variantIsAvailable(v) {
        if (!v) return false
        return v.available !== false
      },

      // ── Image URL helper ─────────────────────────────────────────────
      imageUrlWithWidth(url, width) {
        const src = url != null ? String(url).trim() : ''
        const w = Number(width)
        if (!src) return ''
        if (!w || Number.isNaN(w) || w <= 0) return src
        if (src.includes(' width=')) return src
        if (/[?&]width=\d+/.test(src)) {
          return src.replace(/([?&]width=)\d+/, `$1${w}`)
        }
        const sep = src.includes('?') ? '&' : '?'
        return `${src}${sep}width=${w}`
      },

      // ── Card image helpers (used by aside snippet) ───────────────────
      getCardImageForOption1(option1Key) {
        // Returns the default variant's image for this option1 group
        const defaultId = this.defaultByOption1[option1Key]
        const v = this.getVariantById(defaultId)
        return v && v.image ? this.imageUrlWithWidth(v.image, 248) : ''
      },

      // ── Money formatters ─────────────────────────────────────────────
      formatPdpMoney(cents) {
        const n = Number(cents)
        if (cents == null || cents === '' || Number.isNaN(n)) return ''
        if (typeof window.formatMoney === 'function') {
          return window.formatMoney(n)
        }
        // window.formatMoney is not a global in this theme — convert cents to dollars directly
        return '$' + (n / 100).toFixed(2)
      },

      // ── Terms modal ──────────────────────────────────────────────────
      onTermsAcceptanceChange() {
        this.termsAcceptedAt = this.termsAccepted ? new Date().toISOString() : null
      },

      openTermsModal() {
        this.termsModalOpen = true
        document.body.style.overflow = 'hidden'
      },

      closeTermsModal() {
        this.termsModalOpen = false
        document.body.style.overflow = ''
      },

      // ── Addon product type resolution ────────────────────────────────
      expectedAddonProductTypeForBundle(bundle) {
        if (!bundle || !bundle.option1) return null
        const title = String(bundle.option1)
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (title.indexOf(rules[i].match) !== -1) {
            const rule = rules[i]
            return rule.collectionFilter ? rule.productType + '::' + rule.collectionFilter : rule.productType
          }
        }
        return null
      },

      // ── Swiper navigation helpers ────────────────────────────────────
      slideTo(idx) {
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideTo(idx, 700)
      },

      advanceAddonStep() {
        const root = this.pdpSwiperRootEl
        if (!root) return
        const rootEl = root.querySelector('.pdp-swiper__root')
        if (!rootEl || !rootEl.swiper) return
        rootEl.swiper.slideNext()
        if (typeof window !== 'undefined' && window.matchMedia &&
            window.matchMedia('(max-width: 989px)').matches) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      },

      // ── Step helpers ─────────────────────────────────────────────────

      // True when the user is on whichever step contains the checkout/ATC action.
      // With review step: that's the review slide (index = addonTypeGroups.length + 1).
      // Without review step: that's the last addon step (index = addonTypeGroups.length).
      isOnCheckoutStep() {
        if (this.showReviewStep) {
          return this.currentSwiperIndex === this.addonTypeGroups.length + 1
        }
        return this.addonTypeGroups.length > 0 &&
               this.currentSwiperIndex === this.addonTypeGroups.length
      },

      // True when groupIdx is the last addon type group — used to swap Next → ATC
      // on the desktop next-row when the review step is disabled.
      isLastAddonStep(groupIdx) {
        return groupIdx === this.addonTypeGroups.length - 1
      },

      // ── Mobile CTA helpers ───────────────────────────────────────────
      mobileNextDisabled() {
        if (this.isOnCheckoutStep()) {
          // Without the review step, the last addon step IS the checkout
          // step (its Next button swaps to ADD TO CART in place — see the
          // template around line 625), so its own oil/addon quantity still
          // needs validating here, same as the desktop button already does
          // via canAdvanceFromTypeStep(group). With the review step enabled,
          // each prior step already enforced this before letting the user
          // advance, so only terms/loading are left to check.
          if (!this.showReviewStep) {
            const lastGroup = this.addonTypeGroups[this.addonTypeGroups.length - 1]
            if (lastGroup && !this.canAdvanceFromTypeStep(lastGroup)) return true
          }
          return !this.termsAccepted || this.addToCartLoading
        }
        if (this.currentSwiperIndex === 0) return !this.canAdvanceFromStep1()
        const group = this.addonTypeGroups[this.currentSwiperIndex - 1]
        if (!group) return true
        return !this.canAdvanceFromTypeStep(group)
      },

      mobileNextClick() {
        if (this.isOnCheckoutStep()) {
          this.addReviewQtySetToCart()
        } else if (this.currentSwiperIndex === 0) {
          this.buildBundles()
        } else {
          this.advanceAddonStep()
        }
      },

      // ── Addon type group builder ─────────────────────────────────────
      buildAddonTypeGroups(bundles) {
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        const seen = []
        const map = {}
        bundles.forEach((bundle) => {
          const compositeKey = bundle.productType || '__none__'
          if (!map[compositeKey]) {
            const o1 = bundle.option1 || ''
            let realProductType = compositeKey
            let collectionFilter = null
            for (let i = 0; i < rules.length; i++) {
              if (o1.indexOf(rules[i].match) !== -1) {
                realProductType = rules[i].productType
                collectionFilter = rules[i].collectionFilter || null
                break
              }
            }
            map[compositeKey] = { productType: compositeKey, realProductType, count: 0, bundles: [], collectionFilter }
            seen.push(compositeKey)
          }
          map[compositeKey].count++
          map[compositeKey].bundles.push(bundle)
        })
        return seen.map((key, idx) => ({
          ...map[key],
          label: 'Oils ' + (idx + 1),
        }))
      },

      // ── Addon step helpers ───────────────────────────────────────────
      getAddonRowsForGroup(group) {
        const productType = group ? (group.realProductType || group.productType) : null
        const collectionFilter = group ? (group.collectionFilter || null) : null
        const rows = Object.values(this.addonVariantsById)
        const filtered = (!productType || productType === '__none__')
          ? rows
          : rows.filter((row) => {
              if (row.productType !== productType) return false
              if (collectionFilter && row.collectionName !== collectionFilter) return false
              return true
            })
        return filtered.slice(0, 5)
      },

      getAddonQty(productType, variantId) {
        const typeMap = this.addonQtyByType[productType] || {}
        return typeMap[String(variantId)] || 0
      },

      incrementAddonQty(productType, variantId) {
        // Single Selection preselects the first diffuser but allows up to 5 units per selector.
        if (this.singleSelection && this.getAddonQty(productType, variantId) >= 5) return
        const limit = this.addonTypeLimit(productType)
        if (this.addonTypeTotal(productType) >= limit) return
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        typeMap[String(variantId)] = (typeMap[String(variantId)] || 0) + 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
      },

      decrementAddonQty(productType, variantId) {
        const typeMap = { ...(this.addonQtyByType[productType] || {}) }
        const current = typeMap[String(variantId)] || 0
        if (current <= 0) return
        typeMap[String(variantId)] = current - 1
        this.addonQtyByType = { ...this.addonQtyByType, [productType]: typeMap }
      },

      addonTypeTotal(productType) {
        const typeMap = this.addonQtyByType[productType] || {}
        return Object.values(typeMap).reduce((sum, q) => sum + (Number(q) || 0), 0)
      },

      addonTypeLimit(productType) {
        const group = this.addonTypeGroups.find((g) => g.productType === productType)
        return group ? group.count : 0
      },

      canAdvanceFromTypeStep(group) {
        if (!group) return false
        return this.addonTypeTotal(group.productType) === this.addonTypeLimit(group.productType)
      },

      addonTypeSubheadline(group) {
        if (!group) return ''
        const n = group.count
        const unit = n === 1 ? 'Oil' : 'Oils'
        const name = group.bundles[0] ? (group.bundles[0].option1 || '') : ''
        return `Choose at least <strong>${n} ${unit}</strong> for the ${name}`
      },

      // Hint shown under the button grid — reflects the actual number of
      // oils required for THIS diffuser type (group.count scales with how
      // many diffusers of that type were selected in Step 1), not a fixed
      // "one oil" string.
      addonTypeSelectHint(group) {
        if (!group) return ''
        const n = this.addonTypeLimit(group.productType)
        const unit = n === 1 ? 'oil' : 'oils'
        return `Select at least ${n} ${unit}`
      },

      // ── resolvedPairings: expand addonQtyByType into per-bundle pairs ─
      resolvedPairings() {
        const pairs = []
        this.addonTypeGroups.forEach((group) => {
          const typeMap = this.addonQtyByType[group.productType] || {}
          // Expand qty map into flat ordered list of addonVariantIds
          const scentList = []
          Object.entries(typeMap).forEach(([variantId, qty]) => {
            for (let i = 0; i < qty; i++) scentList.push(Number(variantId))
          })
          // Zip sequentially with bundles
          group.bundles.forEach((bundle, idx) => {
            pairs.push({ bundle, addonVariantId: scentList[idx] || null })
          })
        })
        return pairs
      },

      getBundleDiffuserImage(bundle, width) {
        if (!bundle) return ''
        const variant = this.getVariantById(bundle.variantId)
        if (!variant || !variant.image) return ''
        return this.imageUrlWithWidth(variant.image, width || 2000)
      },

      formatStepText(stepNumber) {
        const tmpl = this.stepTextTemplate || 'Step {step_number}: Choose your scent.'
        return tmpl.replace('{step_number}', String(stepNumber))
      },

      // ── Addon pricing ────────────────────────────────────────────────
      mappedDiscountPercentForType(productType) {
        const pt = productType != null ? String(productType).trim() : ''
        if (!pt) return null
        const rules = parseDiscountByProductTypeRules(this.discountByProductTypeMap)
        for (let i = 0; i < rules.length; i++) {
          if (rules[i].productType === pt) return Number(rules[i].percent)
        }
        return null
      },

      normalizedPricing(v) {
        if (!v) return { price: 0, compareAtPrice: 0 }
        const originalPrice = Number(v.price || 0)
        const originalCompare = Number(v.compareAtPrice || 0)
        const mappedPct = this.mappedDiscountPercentForType(v.productType)
        if (mappedPct == null) return { price: originalPrice, compareAtPrice: originalCompare }
        const hasOriginalCompare = originalCompare > originalPrice && originalCompare > 0
        if (hasOriginalCompare) {
          const currentPct = ((originalCompare - originalPrice) / originalCompare) * 100
          if (currentPct > mappedPct) return { price: originalPrice, compareAtPrice: originalCompare }
        }
        const base = hasOriginalCompare ? originalCompare : originalPrice
        if (base <= 0) return { price: originalPrice, compareAtPrice: originalCompare }
        const discounted = Math.max(0, Math.round((base * (100 - mappedPct)) / 100))
        if (discounted >= base) return { price: originalPrice, compareAtPrice: originalCompare }
        return { price: discounted, compareAtPrice: base }
      },

      addonRowById(variantId) {
        return this.addonVariantsById[String(variantId)] || null
      },

      normalizedAddonRowById(id) {
        const row = this.addonRowById(id)
        if (!row) return null
        return this.normalizedPricing(row)
      },


      addonHasCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return false
        return Number(p.compareAtPrice) > Number(p.price)
      },

      addonDisplayCompare(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.compareAtPrice)
      },

      addonDisplayPrice(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        return this.formatPdpMoney(p.price)
      },

      addonSavePercent(variantId) {
        const p = this.normalizedAddonRowById(variantId)
        if (!p) return ''
        const compareAt = Number(p.compareAtPrice || 0)
        const price = Number(p.price || 0)
        if (!compareAt || compareAt <= 0 || compareAt <= price) return ''
        return String(Math.round(((compareAt - price) / compareAt) * 100))
      },

      // ── Feature metadata (How it works / Subscription perks / Why Aroma360) ──
      getFeatureMetadata() {
        // Use the first option1 group with qty > 0; fallback to first variant overall
        const activeOption1 = this.option1Order.find(
          (key) => this.getQty(key) > 0
        )
        const variantId = activeOption1
          ? this.defaultByOption1[activeOption1]
          : Object.values(this.defaultByOption1)[0]
        const v = this.getVariantById(variantId)
        if (v && v.featureMetadata && v.featureMetadata.length) return v.featureMetadata
        // Fallback: any variant for the same option1 that has metadata
        const option1 = v ? v.option1 : null
        if (option1) {
          const match = Object.values(this.variantsById).find(
            (vv) => vv.option1 === option1 && vv.featureMetadata && vv.featureMetadata.length
          )
          if (match) return match.featureMetadata
        }
        return []
      },

      // ── Addon scent data ─────────────────────────────────────────────
      getAddonScentProfile(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentProfile) ? row.scentProfile : []
      },

      getAddonScentMoods(variantId) {
        const row = this.addonRowById(variantId)
        if (!row) return []
        return Array.isArray(row.scentMoods) ? row.scentMoods : []
      },

      // ── Review step helpers ──────────────────────────────────────────

      reviewAddonRowForBundle(bundle) {
        if (!bundle) return null
        const pair = this.resolvedPairings().find(
          (p) => p.bundle.bundleId === bundle.bundleId
        )
        if (!pair || !pair.addonVariantId) return null
        return this.addonRowById(pair.addonVariantId) || null
      },

      reviewSumPriceCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          if (!pair.addonVariantId) return total
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return total + (row ? Number(row.price) || 0 : 0)
        }, 0)
      },

      reviewSumCompareAtCents() {
        return this.resolvedPairings().reduce((total, pair) => {
          if (!pair.addonVariantId) return total
          const row = this.normalizedAddonRowById(pair.addonVariantId)
          return total + (row ? Number(row.compareAtPrice) || Number(row.price) || 0 : 0)
        }, 0)
      },

      // Sum of compare-at prices for every selected diffuser unit.
      // Used to display the dynamic cancel charge on each oil step.
      // Variants are stored in variantsById (map by ID), not an array.
      diffuserCancelPriceCents() {
        let total = 0
        Object.entries(this.quantityByOption1).forEach(([option1Key, qty]) => {
          const q = Number(qty) || 0
          if (q <= 0) return
          if (option1Key === '__bundle__') {
            // Bundle card — use the bundle variant's realPrice
            const bv = this.bundleVariant
            if (bv) total += (Number(bv.realPrice) || 0) * q
          } else {
            // Find the first variant in variantsById that matches this option1
            const variant = Object.values(this.variantsById || {}).find(v => v.option1 === option1Key)
            if (variant) total += (Number(variant.realPrice) || 0) * q
          }
        })
        return total
      },

      formatPdpMoneyOrFree(cents) {
        const n = Number(cents)
        if (!n || n <= 0) return 'FREE'
        return this.formatPdpMoney(n)
      },

      // ── Cart helpers (mirror existing section) ───────────────────────

      buildBundleId(mainVariantId, addonVariantId) {
        return `_bundle_${mainVariantId}_${addonVariantId}_plan_30_ts_${Date.now()}`
      },

      compareAtCentsString(variantRow) {
        if (!variantRow) return '0'
        const c = Number(variantRow.compareAtPrice || 0)
        if (!c || c <= 0) return '0'
        return String(Math.round(c))
      },

      compareDiscountPercentString(variantRow) {
        if (!variantRow) return '0'
        const cap = Number(variantRow.compareAtPrice || 0)
        const price = Number(variantRow.price || 0)
        if (!cap || cap <= 0 || cap <= price) return '0'
        const pct = Math.round(((cap - price) / cap) * 100)
        return String(Math.max(0, pct))
      },

      buildBundleLineProperties(variantRow, bundleId, tosAcceptedAt) {
        return {
          _bundle_promo: 'free-diffuser-set',
          _bundle_id: bundleId,
          _bundle_identifier: 'true',
          _compare_at_price: this.compareAtCentsString(variantRow),
          _compare_at_price_discount: this.compareDiscountPercentString(variantRow),
          _free_diffuser_tos_aceptance:
            tosAcceptedAt != null && tosAcceptedAt !== '' ? String(tosAcceptedAt) : '',
        }
      },

      // ── Add to cart ──────────────────────────────────────────────────

      async addReviewQtySetToCart() {
        if (!this.termsAccepted || this.addToCartLoading) return
        this.addToCartLoading = true
        try {
          const tosAt = this.termsAcceptedAt
          const items = []

          for (const pair of this.resolvedPairings()) {
            const bundle = pair.bundle
            const mainVariant = this.getVariantById(bundle.variantId)
            if (!mainVariant) continue

            const addonRow = pair.addonVariantId ? this.addonRowById(pair.addonVariantId) : null
            const addonEligible = addonRow && addonRow.available !== false
            const resolvedAddonId = addonEligible ? Number(pair.addonVariantId) : 0

            const bundleId = bundle.bundleId || this.buildBundleId(Number(bundle.variantId), resolvedAddonId)

            // Diffuser line item
            items.push({
              id: Number(bundle.variantId),
              quantity: 1,
              properties: this.buildBundleLineProperties(mainVariant, bundleId, tosAt),
            })

            // Scent line item
            if (addonEligible) {
              const addonLine = {
                id: resolvedAddonId,
                quantity: 1,
                properties: this.buildBundleLineProperties(addonRow, bundleId, tosAt),
              }
              const sp = addonRow.sellingPlanId
              if (sp != null && sp !== '') addonLine.selling_plan = Number(sp)
              items.push(addonLine)
            }
          }

          if (!items.length) return

          const rootPath =
            typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/'

          const res = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items }),
          })
          const data = await res.json().catch(() => ({}))
          if (!res.ok || data.status === 422) {
            console.error('[pdp-swiper-qty] cart/add error:', data)
            return
          }

          // Notify hc-new-theme's cart drawer to refresh and open
          if (window.HotelCollection) {
            if (typeof window.HotelCollection.refreshCart === 'function') {
              await window.HotelCollection.refreshCart()
            }
            if (typeof window.HotelCollection.openCart === 'function') {
              window.HotelCollection.openCart()
            }
          }

        } catch (err) {
          console.error('[pdp-swiper-qty] addReviewQtySetToCart error:', err)
        } finally {
          this.addToCartLoading = false
        }
      },

      // ── Popup (Learn More) ──────────────────────────────────────────
      openVariantPopup(option1Key) {
        this.popupOption1 = option1Key
        const id = this.defaultByOption1[option1Key]
        const v = id ? this.variantsById[String(id)] : null
        if (!v) {
          const fallback = Object.values(this.variantsById).find((vv) => vv.option1 === option1Key)
          if (!fallback) return
          this.popupVariant = fallback
        } else {
          this.popupVariant = v
        }
        this.popupOpen = true
        this.popupSectionsHtml = ''
        this.$nextTick(() => {
          this.fetchPopupSections(this.popupLinkedProductHandle())
          this.fetchMainProductOkendoRating()
        })
      },
      closePopup() {
        this.popupOpen = false
        this.popupVariant = null
        this.popupOption1 = null
      },
      popupAccordionItems() {
        const option1 = this.popupOption1
        const all = Object.values(this.variantsById)
        const match = all.find((v) => v.option1 === option1 && v.accordionItems?.length)
        return match?.accordionItems || this.popupVariant?.accordionItems || []
      },
      popupLinkedProductHandle() {
        const items = this.popupAccordionItems()
        const item = items.find((i) => i.linkedProductHandle)
        if (item?.linkedProductHandle) return item.linkedProductHandle
        if (this.popupVariant?.popupProductHandle) return this.popupVariant.popupProductHandle
        return null
      },
      _initPopupSectionAnimations() {
        const container = this.$refs.popupSections
        if (!container) return
        const store = Alpine.store('xScrollPromotion')
        if (store) {
          const bannerEl = container.querySelector('.el_animate')?.closest('[class*="section-"]')
          if (bannerEl) { store.load(bannerEl) }
        }
        container.querySelectorAll('.el_animate').forEach((el) => {
          el.classList.add('animate-scroll-banner')
        })
        requestAnimationFrame(() => {
          container.querySelectorAll('marquee-text').forEach((el) => {
            const w = el.getBoundingClientRect().width
            if (!w) return
            const speed = parseInt(el.getAttribute('scrolling-speed') || 5)
            const span = el.querySelector('span')
            if (!span) return
            const slowFactor = 1 + (Math.min(1600, w) - 375) / (1600 - 375)
            const duration = (speed * slowFactor * span.clientWidth / w).toFixed(3)
            el.style.setProperty('--marquee-animation-duration', `${duration}s`)
          })
        })
      },
      async fetchPopupSections(handle) {
        if (!handle) return
        if (this.popupSectionsCache[handle] !== undefined) {
          this.popupSectionsHtml = this.popupSectionsCache[handle]
          await this.$nextTick()
          this._initPopupSectionAnimations()
          return
        }
        const items = this.popupAccordionItems()
        const sourceItem = items.find((i) => i.linkedProductHandle === handle)
        let sectionIds = [sourceItem?.popupSection1, sourceItem?.popupSection2].filter(Boolean)
        if (sectionIds.length === 0) {
          // Match by section type prefix only — Shopify appends a random suffix to section IDs
          // that changes per theme/customizer save, so we can't rely on the full ID.
          // Using type prefixes with querySelectorAll captures all instances (e.g. multiple
          // media_with_text sections) without needing to know the generated suffix.
          const sectionMap = {
            'studio-scent-diffuser': ['scrolling_text_v2_', 'media_with_text_', 'multi_column_'],
            'chauffeur-car-diffuser': ['scrolling_text_v2_']
          }
          sectionIds = sectionMap[handle] || (this.popupVariant?.productType === 'Oil' ? ['scrolling_text_v2_'] : [])
        }
        const ratingId = 'pdp-popup-okendo-rating'
        try {
          const res = await fetch(`${window.location.origin}/products/${handle}`)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const ratingSection = doc.querySelector(`#shopify-section-${ratingId}`)
          if (ratingSection && this.popupVariant) {
            const tmp = document.createElement('div')
            tmp.innerHTML = ratingSection.outerHTML
            const el = tmp.querySelector('[data-popup-okendo-rating]')
            if (el) {
              try {
                const rd = JSON.parse(el.textContent)
                this.popupVariant = { ...this.popupVariant, reviewCount: rd.reviewCount, reviewRating: rd.reviewRating }
              } catch(e) {}
            }
          }
          let sectionHtml = ''
          // querySelectorAll collects every section matching the type prefix (handles duplicates)
          sectionIds.forEach((sectionPrefix) => {
            doc.querySelectorAll(`[id*="${sectionPrefix}"]`).forEach(section => {
              sectionHtml += section.outerHTML
            })
          })
          this.popupSectionsCache[handle] = sectionHtml
          this.popupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initPopupSectionAnimations()
        } catch (e) {
          console.error('Error fetching popup sections:', e)
          this.popupSectionsCache[handle] = ''
          this.popupSectionsHtml = ''
        }
      },
      async fetchMainProductOkendoRating() {
        let mainHandle = 'studio-scent-diffuser'
        const variantTitle = this.popupVariant?.title || ''
        if (variantTitle.includes('Chauffeur')) {
          mainHandle = 'chauffeur-car-diffuser'
        }
        try {
          const res = await fetch(`${window.location.origin}/products/${mainHandle}`)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const okendoElement = doc.querySelector('[data-oke-reviews-product-listing-rating]')
          if (okendoElement && this.popupVariant) {
            this.popupVariant = { ...this.popupVariant, okendoSnippetHtml: okendoElement.outerHTML }
          }
        } catch (e) {
          console.error('Error fetching main product Okendo rating:', e)
        }
      },
      popupSelectSwatch(variantId) {
        const v = this.variantsById[String(variantId)]
        if (v) this.popupVariant = v
      },
      popupSwatches() {
        if (!this.popupOption1) return []
        const swatches = []
        const seen = {}
        Object.values(this.variantsById).forEach((v) => {
          if (v.option1 !== this.popupOption1) return
          if (!v.available) return
          if (!v.option2 || seen[v.option2]) return
          seen[v.option2] = true
          swatches.push({ id: v.id, label: v.option2, bg: v.swatchBg || '#e0e0e0' })
        })
        return swatches
      },
      isPopupSwatchActive(variantId) {
        return this.popupVariant && Number(this.popupVariant.id) === Number(variantId)
      },
      popupFeatures() {
        if (!this.popupVariant) return []
        return Array.isArray(this.popupVariant.allFeatures) ? this.popupVariant.allFeatures : []
      },
      popupTitle() {
        if (!this.popupVariant) return ''
        return this.popupVariant.option1 || this.popupVariant.title || ''
      },
      popupImage() {
        if (!this.popupVariant) return ''
        return this.popupVariant.image || ''
      },
      popupCompareAtPrice() {
        if (!this.popupVariant) return ''
        const c = Number(this.popupVariant.compareAtPrice || 0)
        const p = Number(this.popupVariant.realPrice || 0)
        if (c > p) return this.formatPdpMoney(c)
        return ''
      },
      richTextToHtml(json) {
        if (!json) return ''
        let tree
        try { tree = typeof json === 'string' ? JSON.parse(json) : json }
        catch (e) { return json }
        function walk(node) {
          if (!node) return ''
          if (node.type === 'text') {
            let t = (node.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            if (node.bold)   t = '<strong>' + t + '</strong>'
            if (node.italic) t = '<em>' + t + '</em>'
            if (node.code)   t = '<code>' + t + '</code>'
            return t
          }
          const inner = (node.children || []).map(walk).join('')
          switch (node.type) {
            case 'root':      return inner
            case 'paragraph': return '<p>' + inner + '</p>'
            case 'heading':   return '<h' + node.level + '>' + inner + '</h' + node.level + '>'
            case 'list':      return node.listType === 'ordered' ? '<ol>' + inner + '</ol>' : '<ul>' + inner + '</ul>'
            case 'list-item': return '<li>' + inner + '</li>'
            case 'link':      return '<a href="' + (node.url || '') + '"' + (node.target ? ' target="' + node.target + '"' : '') + '>' + inner + '</a>'
            default:          return inner
          }
        }
        return walk(tree)
      },

      decodeEscapedHtml(str) {
        if (!str) return ''
        return str
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
      },

      formatNotes(val) {
        if (!val) return ''
        const html = this.richTextToHtml(val)
        if (html !== val) return html
        return val.split(/\n|\r\n/).filter(l => l.trim()).map(line => {
          const idx = line.indexOf(':')
          if (idx > -1) {
            const label = line.slice(0, idx).trim()
            const rest  = line.slice(idx + 1).trim()
            return '<p><strong>' + label + '</strong>: ' + rest + '</p>'
          }
          return '<p>' + line + '</p>'
        }).join('')
      },

      // ── Review image ────────────────────────────────────────────────
      reviewMappedImageUrl() {
        const bundles = this.bundles || []
        const option1 = bundles.length ? (bundles[0].option1 || '') : ''
        const rules = parseQtyAddonProductTypeRules(this.addonProductTypeMap)
        let productType = null
        for (let i = 0; i < rules.length; i++) {
          if (option1.indexOf(rules[i].match) !== -1) { productType = rules[i].productType; break }
        }
        const mappings = Array.isArray(this.reviewImageMappings) ? this.reviewImageMappings : []
        for (let i = 0; i < mappings.length; i++) {
          const row = mappings[i] || {}
          const rowRules = parseQtyAddonProductTypeRules(row.map || '')
          for (let j = 0; j < rowRules.length; j++) {
            const matches = productType
              ? rowRules[j].productType === productType
              : option1.indexOf(rowRules[j].match) !== -1
            if (matches && row.imageUrl) return row.imageUrl
          }
        }
        return this.productFeaturedImage || ''
      },

      // ── All-Scents modal ─────────────────────────────────────────────
      currentAddonProductType() {
        return this._allScentsProductType || null
      },
      openAllScentsModal(productType, collectionFilter) {
        this._allScentsProductType = productType || null
        this._allScentsCollectionFilter = collectionFilter || null
        this.allScentsModalOpen = true
        this.allScentsDrawerOpen = false
        document.body.style.overflow = 'hidden'
      },
      closeAllScentsModal() {
        this.allScentsModalOpen = false
        this.allScentsDrawerOpen = false
        document.body.style.overflow = ''
      },
      openAllScentsDrawer() {
        this.allScentsDrawerOpen = true
      },
      closeAllScentsDrawer() {
        this.allScentsDrawerOpen = false
      },
      addonRowById(variantId) {
        return this.addonVariantsById[String(variantId)] || null
      },
      allScentsCardImage(variantId) {
        const row = this.addonRowById(variantId)
        if (!row || !row.cardImage) return ''
        const desktop = typeof window !== 'undefined' && window.matchMedia
          ? window.matchMedia('(min-width: 990px)').matches
          : false
        return this.imageUrlWithWidth(row.cardImage, desktop ? 512 : 248)
      },
      normalizeFilterText(value) {
        if (value == null) return ''
        return String(value).trim().toLowerCase()
      },
      isAddonVariantVisible(addonVariantId) {
        const row = this.addonVariantsById[String(addonVariantId)]
        if (!row) return false
        if (row.available === false) return false
        const sp = row.sellingPlanId
        if (sp == null || sp === '' || Number(sp) <= 0) return false
        const compositeKey = this._allScentsProductType
        if (!compositeKey) return true
        const group = this.addonTypeGroups.find((g) => g.productType === compositeKey)
        const realPt = group ? (group.realProductType || group.productType) : compositeKey
        const rowPt = row.productType != null ? String(row.productType).trim() : ''
        if (rowPt !== realPt) return false
        const cf = this._allScentsCollectionFilter
        if (cf) {
          const rowCn = row.collectionName != null ? String(row.collectionName).trim() : ''
          if (rowCn !== cf) return false
        }
        return true
      },
      availableInspiredByOptions() {
        const out = []
        const seen = {}
        const ids = Object.keys(this.addonVariantsById)
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const row = this.addonVariantsById[String(id)]
          const rawName = row && row.inspiredBy != null ? String(row.inspiredBy).trim() : ''
          if (!rawName) continue
          const key = this.normalizeFilterText(rawName)
          if (seen[key]) continue
          seen[key] = true
          out.push({ name: rawName })
        }
        return out
      },
      isInspiredByFilterSelected(name) {
        return this.selectedInspiredByFilters.includes(this.normalizeFilterText(name))
      },
      toggleInspiredByFilter(name) {
        const key = this.normalizeFilterText(name)
        if (!key) return
        if (this.selectedInspiredByFilters.includes(key)) {
          this.selectedInspiredByFilters = this.selectedInspiredByFilters.filter((x) => x !== key)
        } else {
          this.selectedInspiredByFilters = [...this.selectedInspiredByFilters, key]
        }
      },
      addonMatchesInspiredByFilter(variantId) {
        if (!this.selectedInspiredByFilters.length) return false
        const row = this.addonRowById(variantId)
        const name = this.normalizeFilterText(row && row.inspiredBy != null ? String(row.inspiredBy) : '')
        if (!name) return false
        return this.selectedInspiredByFilters.includes(name)
      },
      addonMatchesSelectedFilters(variantId) {
        if (!this.selectedInspiredByFilters.length) return true
        return this.addonMatchesInspiredByFilter(variantId)
      },
      addonMatchesSearch(row) {
        const q = this.normalizeFilterText(this.allScentsSearch)
        if (!q) return true
        const title = row && row.cardTitle ? this.normalizeFilterText(row.cardTitle) : ''
        const inspiredBy = row && row.inspiredBy ? this.normalizeFilterText(row.inspiredBy) : ''
        return title.includes(q) || inspiredBy.includes(q)
      },
      filteredAddonVariantIds() {
        const ids = Object.keys(this.addonVariantsById)
        const out = []
        for (let i = 0; i < ids.length; i++) {
          const id = Number(ids[i])
          if (!this.isAddonVariantVisible(id)) continue
          const row = this.addonRowById(id)
          if (!row) continue
          if (!this.addonMatchesSearch(row)) continue
          if (!this.addonMatchesSelectedFilters(id)) continue
          out.push(id)
        }
        return out
      },
      allScentsSubheadline() {
        const pt = this._allScentsProductType
        const group = pt ? this.addonTypeGroups.find((g) => g.productType === pt) : null
        return this.addonTypeSubheadline(group)
      },
      selectAddonFromAllScents() {
        this.closeAllScentsModal()
        this.$nextTick(() => {
          this.advanceAddonStep()
        })
      },

      // ── Addon popup ──────────────────────────────────────────────────
      openAddonPopup(addonVariantId) {
        const v = this.addonRowById(addonVariantId)
        if (v) {
          this.addonPopupVariant = v
          this.addonPopupOpen = true
          this.addonPopupSectionsHtml = ''
          this.$nextTick(() => {
            this.fetchAddonPopupSections(v.handle)
          })
        }
      },
      closeAddonPopup() {
        this.addonPopupOpen = false
        this.addonPopupVariant = null
      },
      addonPopupTitle() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardTitle || ''
      },
      addonPopupImage() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.cardImage || ''
      },
      addonPopupPrice() {
        if (!this.addonPopupVariant) return ''
        return this.formatPdpMoney(this.addonPopupVariant.price)
      },
      addonPopupCompareAtPrice() {
        if (!this.addonPopupVariant) return ''
        const c = Number(this.addonPopupVariant.compareAtPrice || 0)
        const p = Number(this.addonPopupVariant.price || 0)
        if (c > p) return this.formatPdpMoney(c)
        return ''
      },
      addonPopupHasCompare() {
        if (!this.addonPopupVariant) return false
        return Number(this.addonPopupVariant.compareAtPrice) > Number(this.addonPopupVariant.price)
      },
      addonPopupSavePercent() {
        if (!this.addonPopupVariant) return ''
        const c = Number(this.addonPopupVariant.compareAtPrice || 0)
        const p = Number(this.addonPopupVariant.price || 0)
        if (c > p && c > 0) return Math.round(((c - p) / c) * 100) + '%'
        return ''
      },
      addonPopupScentProfile() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentProfile) ? this.addonPopupVariant.scentProfile : []
      },
      addonPopupScentMoods() {
        if (!this.addonPopupVariant) return []
        return Array.isArray(this.addonPopupVariant.scentMoods) ? this.addonPopupVariant.scentMoods : []
      },
      addonPopupInspiredBy() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.inspiredBy || ''
      },
      addonPopupDescription() {
        if (!this.addonPopupVariant) return ''
        return this.addonPopupVariant.description || ''
      },
      _initAddonPopupSectionAnimations() {
        const container = this.$refs.addonPopupSections
        if (!container) return
        container.querySelectorAll('.el_animate').forEach(el => {
          el.classList.add('animate-scroll-banner')
        })
      },
      async fetchAddonPopupSections(handle) {
        if (!handle) return
        if (this.addonPopupSectionsCache[handle] !== undefined) {
          this.addonPopupSectionsHtml = this.addonPopupSectionsCache[handle]
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
          return
        }
        // Match by section type prefix — same approach as fetchPopupSections
        const sectionIds = ['scrolling_banner_', 'image_with_text_']
        try {
          const url = `${window.location.origin}/products/${handle}`
          const res = await fetch(url)
          const html = await res.text()
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          let sectionHtml = ''
          sectionIds.forEach(sectionPrefix => {
            doc.querySelectorAll(`[id*="${sectionPrefix}"]`).forEach(section => {
              sectionHtml += section.outerHTML
            })
          })
          this.addonPopupSectionsCache[handle] = sectionHtml
          this.addonPopupSectionsHtml = sectionHtml
          await this.$nextTick()
          this._initAddonPopupSectionAnimations()
        } catch (e) {
          this.addonPopupSectionsCache[handle] = ''
          this.addonPopupSectionsHtml = ''
        }
      },

    }))
  })


  } catch(e) { console.error(e); }
})();
})();
